import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M7.65 9 4.725 6.075a.71.71 0 0 1-.206-.525q0-.319.206-.525a.71.71 0 0 1 .525-.206q.318 0 .525.206l3.45 3.45a.7.7 0 0 1 .16.244.862.862 0 0 1 0 .563.64.64 0 0 1-.16.243l-3.45 3.45a.71.71 0 0 1-.525.206.71.71 0 0 1-.525-.206.71.71 0 0 1-.206-.525q0-.318.206-.525zm5.1-4.5q.318 0 .535.216a.72.72 0 0 1 .215.534v7.5q0 .319-.216.535a.72.72 0 0 1-.534.215.73.73 0 0 1-.534-.216.72.72 0 0 1-.216-.534v-7.5q0-.319.216-.534a.73.73 0 0 1 .534-.216"
    }, null, -1)
  ]))]))
}
export default { render: render }